import { render } from "./Duels.vue?vue&type=template&id=5f9ee749&scoped=true"
import script from "./Duels.vue?vue&type=script&lang=js"
export * from "./Duels.vue?vue&type=script&lang=js"

import "./Duels.vue?vue&type=style&index=0&id=5f9ee749&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9ee749"]])

export default __exports__